import { CustomerState } from './types';

export const getCustomerFirstName = (state: CustomerState) => state.customer.firstName;
export const getCustomerLastName = (state: CustomerState) => state.customer.lastName;
export const getCustomerEmail = (state: CustomerState) => state.customer.email;
export const getCustomerMobile = (state: CustomerState) => state.customer.mobile;
export const getCustomerTerms = (state: CustomerState) => state.customer.terms;
export const getCustomerMarketing = (state: CustomerState) => state.customer.marketing;
export const getCustomerDealerBranch = (state: CustomerState) => state.customer.dealerBranch;

